export default __webpack_public_path__ + "static/media/stage_released.09fa7579.svg";